export const environment = {
  production: true,
  apiUrl: 'https://api.rendervine.com/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts